export default "__VITE_ASSET__CGjm7I96__"